export enum ImageTypeEnum {
    SIGNATURE = "SIGNATURE",
    POD = "POD",
    DO = "DO",
    UNDEL = "UNDEL"
}
export enum ImageTypeEnumPath {
    SIGNATUREPath = "assets/img/business.jpg",
    PODPath = "assets/img/business.jpg",
    DOPath = "assets/img/business.jpg",
    UNDELPath = "assets/img/business.jpg",
    DefualtPath="assets/img/logo150x50.png"
}